import React, { useEffect } from 'react';
import utils from '@/common/utils';
import Container from '@/components/container';
import TabNav from '@/components/slide-menu/tab-nav';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';

export default function List(props) {
  const isManage = !Number(utils.getQuery('entry'));
  // activityVersion 开放报名3
  // 会场活动4 新加的
  // 只有会场活动才有流程数据 activityInfo.activityVersion === 4
  return (
    <Container>
      <ContextProviderMenus.Provider value={{ children: props.children, isManage }}>
        <TabNav className="padding-horizontal" />
        {props.children}
      </ContextProviderMenus.Provider>
    </Container>
  );
}
